/*
 * @format
 */

import * as actionTypes from './action-types';
import { sortHomesById } from './utils/helpers';

// [
// { deviceId: "id", selected: true}
// { deviceId: "id2", selected: false}
// ]

// {
//   si: {
//     boilerControl: '',
//     firmwareVersionSi: '',
//     pairingModeState: 0,
//     bootupReason: '',
//     powerupTime: '',
//     diagnosticsIntervalSeconds: 0,
//     modelName: '',
//     networkSsid: '',
//     wifiRssi: 0,
//     zigbeeChannel: 0,
//     connected: true,
//     inFailsafe: false,
//     userOverridenOn: false,
//     userOverridenOff: false,
//   },
//   boiler: {
//     openThermCommunication: false,
//     faults: [
//       {
//         FaultCode: 'F5',
//         RaisedAt: 1571061539306,
//         Severity: 'Critical',
//         Description: 'Return thermistor short circuit (lockout after 24h) ',
//         ResolutionText:
//           "The boiler in this property is showing a 'return thermistor fault', please contact the tenant and ask them to press the restart button on the front of the boiler.\n\n      If the fault returns after the boiler has been restarted please book an engineer to attend the property, on the call notes please advise the boiler is displaying a 'return thermistor fault'.",
//         GasSafeEngineerRequired:
//           'Once restarted the boiler if the failure continues, a ‘Gas Safe’ engineer is needed',
//       },
//     ],
//   },
//   homes: [
//     {
//       id: '08123913724821',
//       friendlyName: 'Sauce Office',
//       connectedDevice: true,
//       zones: {
//         zoneId: ['prt-123', 0],
//         type: 'CH',
//         mode: 'auto',
//         temperature: 2150,
//         setpoint: 2300,
//         plusHoursActive: true,
//         flame: false,
//         optimisedStartActive: true,
//         optimisedStopActive: true,
//         delayedStartActive: false,
//         connectionStatus: true,
//         schedule: [
//           {
//             day: 'Sunday',
//             events: [
//               {
//                 startTime: 555,
//                 endTime: 600,
//                 setpoint: 1900,
//               },
//               {
//                 startTime: 600,
//                 endTime: 1230,
//                 setpoint: 2100,
//               },
//             ],
//           },
//         ],
//       },
//     },
//   ],
// };

export const homelistInitialState = {
  // selectedHome: '',
  hadFirstHello: false,
  firstHelloWasEmpty: false,
  // si: {},
  // hpi: {},
  // boiler: {},
  homes: [],
  liveData: [],
};

const parseGeoDevice = (device, deviceRegistrationId) => {
  if (device.Id) {
    return {
      id: device.Id,
      deviceRegistrationId,
      accountId: device.AccountId,
      friendlyName: device.FriendlyName,
      sensitivity: device.Sensitivity,
      currentZone: device.CurrentZone,
      previousZone: device.PreviousZone,
      lastSeenAt: device.LastSeenAt,
      createdAt: device.CreatedAt,
      updatedAt: device.UpdatedAt,
    };
  }
  return device;
};

const parseZone = zone => {
  // Central Heating
  if (zone.type === 'CH') {
    return {
      zoneId: zone.zoneId,
      type: zone.type,
      modelIdentifier: zone.modelIdentifier,
      friendlyName: zone.friendlyName,
      mode: zone.temperatureMode,
      temperature: zone.localTemperature,
      setpoint: zone.heatingSetpoint,
      previousSetpoint: zone.previousSetpoint,
      previousTemperatureMode: zone.previousTemperatureMode,
      flame: zone.flame,
      frostProtectionSetpoint: zone.frostProtectionSetpoint,
      schedule: zone.schedule,
      overrideEndtime: zone.overrideEndtime,
      connected: zone.connectionStatus,
      holidayMode: zone.holidayMode,
      holidayModeEnd: zone.holidayModeEnd,
      optimisedStartActive: zone.optimisedStartActive,
      optimisedStopActive: zone.optimisedStopActive,
      delayedStartActive: zone.delayedStartActive,
      optimisedStartEnabled: zone.optimisedStartEnabled,
      optimisedStopEnabled: zone.optimisedStopEnabled,
      delayedStartEnabled: zone.delayedStartEnabled,
      lastMessageRssi: zone.lastMessageRssi,
      connectionStrength: zone.connectionStrength,
      connectionStatus: zone.connectionStatus,
      batteryLevel: zone.batteryLevel,
      temperatureOffset: zone.temperatureOffset,
      firmwareVersion: zone.firmwareVersionPrt,
      childLock: zone.childLock,
      roomThermistor: zone.roomThermistor,
      identifyModeActive: zone.identifyModeActive,
      displayToleranceDot1: zone.displayToleranceDot1,
      timeFormat: zone.timeFormat,
      geolocationState: zone.geolocationState,
      upperLimitLock: zone.upperLimitLock,
      lowerLimitLock: zone.lowerLimitLock,
      installerContactNumber: zone.installerContactNumber,
      serviceModeType: zone.serviceModeType,
      serviceModeDaysRemaining: zone.serviceModeDaysRemaining,
      serviceModeSetpoint: zone.serviceModeSetpoint,
    };
  }
  // Hot Water
  if (zone.type === 'DHW') {
    return {
      zoneId: zone.zoneId,
      type: zone.type,
      modelIdentifier: zone.modelIdentifier,
      friendlyName: zone.friendlyName,
      flame: zone.flame,
      schedule: zone.schedule,
      mode: zone.temperatureMode,
      holidayMode: zone.holidayMode,
      holidayModeEnd: zone.holidayModeEnd,
      connectionStrength: zone.connectionStrength,
      connectionStatus: zone.connectionStatus,
      connected: zone.connectionStatus,
      batteryLevel: zone.batteryLevel,
      timeFormat: zone.timeFormat,
      overrideEndtime: zone.overrideEndtime,
      previousMode: zone.previousMode,
    };
  }

  // Halo Air Heating
  if (zone.type === 'HPI_CH') {
    return {
      zoneId: zone.zoneId,
      type: zone.type,
      mode: zone.temperatureMode,
      friendlyName: zone.friendlyName,
      connectionStatus: zone.connectionStatus,
      connected: zone.connectionStatus,
      batteryLevel: zone.batteryLevel,
      batteryVoltage: zone.batteryVoltage,
      firmwareVersion: zone.firmwareVersionPrt,
      temperature: zone.localTemperature,
      setpoint: zone.heatingSetpoint,
      timeFormat: zone.timeFormat,
      schedule: zone.schedule,
      overrideEndtime: zone.overrideEndtime,
      holidayMode: zone.holidayMode,
      holidayModeEnd: zone.holidayModeEnd,
      frostProtectionSetpoint: zone.frostProtectionSetpoint,
      upperLimitLock: zone.upperLimitLock,
      lowerLimitLock: zone.lowerLimitLock,
      // TODO remove the parseInts when the spec is updated
      comfortTemperatureSetpoint: parseInt(zone.comfortTemperatureSetpoint, 10),
      reducdedTemperatureSetpoint: parseInt(
        zone.reducdedTemperatureSetpoint,
        10,
      ),
      installerContactNumber: zone.installerContactNumber,
      childLock: zone.childLock,
      temperatureOffset: zone.temperatureOffset,
      displayToleranceDot1: zone.displayToleranceDot1,
      timedDhw: zone.timedDhw,
      lastMessageRssi: zone.lastMessageRssi,
      optimisedStartMaxTime: zone.optimisedStartMaxTime,
      optimisedStopMaxTime: zone.optimisedStopMaxTime,
      identifyModeActive: zone.identifyModeActive,
      optimisedStartActive: zone.optimisedStartActive,
      previousMode: zone.previousMode,
    };
  }

  if (zone.type === 'HPI_DHW') {
    return {
      zoneId: zone.zoneId,
      type: zone.type,
      friendlyName: zone.friendlyName,
      schedule: zone.dhwSchedule,
      mode: zone.temperatureMode,
      overrideEndtime: zone.overrideEndtime,
    };
  }

  return {};
};

const parseBoiler = boiler => {
  if (boiler) {
    return {
      openThermCommunication: boiler.openThermCommunication,
      boilerType: boiler.boilerType,
      capacity: boiler.capacity,
      id003: boiler.id003,
      id011: boiler.id011,
      id125: boiler.id125,
      id127: boiler.id127,
      faults: boiler.faults,
    };
  }

  return '';
};

const parseSi = si => {
  if (si) {
    return {
      connected: si.connected,
      boilerControl: si.boilerControl,
      firmwareVersionSi: si.firmwareVersionSi,
      pairingModeState: si.pairingModeState,
      bootupReason: si.bootupReason,
      powerupTime: si.powerupTime,
      diagnosticsIntervalSeconds: si.diagnosticsIntervalSeconds,
      modelName: si.modelName,
      networkSsid: si.networkSsid,
      wifiRssi: si.wifiRssi,
      connectionStrength: si.connectionStrength,
      zigbeeChannel: si.zigbeeChannel,
      inFailsafe: si.inFailsafe,
      userOverridenOn: si.userOverridenOn,
      userOverridenOff: si.userOverridenOff,
      heatCurveEnabled: si.heatCurveEnabled,
      heatCurveNumber: si.heatCurveNumber,
      heatCurveNominalTemp: si.heatCurveNominalTemp,
    };
  }

  return '';
};

const parseHpi = hpi => {
  if (hpi) {
    return {
      connected: hpi.connected,
      firmwareVersionHpi: hpi.firmwareVersionHpi,
      pairingModeState: hpi.pairingModeState,
      bootupReason: hpi.bootupReason,
      powerupTime: hpi.powerupTime,
      diagnosticsIntervalSeconds: hpi.diagnosticsIntervalSeconds,
      modelName: hpi.modelName,
      networkSsid: hpi.networkSsid,
      wifiRssi: hpi.wifiRssi,
      zigbeeChannel: hpi.zigbeeChannel,
      inFailsafe: hpi.inFailsafe,
      userOverridenOn: hpi.userOverridenOn,
      userOverridenOff: hpi.userOverridenOff,
      faults: hpi.faults,
      dsrEnabled: hpi.dsrEnabled || hpi.DSREnabled,
      dhwEmergencyOperation: hpi.dhwEmergencyOperation,
      serviceTime: hpi.serviceTime,
      serviceInterval: hpi.serviceInterval,
    };
  }

  return undefined;
};

const parseLogic = logic => {
  if (logic) {
    return {
      connected: logic.connected,
      faults: logic.faults,
    };
  }

  return undefined;
};

const updateHomeGeolocationDevices = (state, homeId, geolocationDevices) => {
  return {
    ...state,
    homes: [
      ...state.homes.filter(x => x.id !== homeId),
      {
        ...state.homes.find(x => x.id === homeId),
        geolocationDevices,
      },
    ].sort(sortHomesById),
  };
};

const setDsrStatus = (state, homeId, dsrEnabled) => {
  let homes = [];

  for (let i = 0; i < state.homes.length; i++) {
    const home = state.homes[i];

    if (home.id === homeId) {
      const homeWithDsrNewDsrStatus = {
        ...home,
        hpi: { ...home?.hpi, dsrEnabled },
      };

      homes.push(homeWithDsrNewDsrStatus);
    } else {
      homes.push(home);
    }
  }

  return homes;
};

export const homeList = (state = homelistInitialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT_COMPLETED:
      return homelistInitialState;

    case actionTypes.REMOVE_HOME: {
      const { homeId } = action;

      const homeStillInHomes = state.homes.find(x => x.id === homeId);

      if (homeStillInHomes) {
        const homesWithoutDeregisteredHome = state.homes.filter(
          x => x.id !== homeId,
        );

        return {
          ...state,
          homes: homesWithoutDeregisteredHome,
        };
      }

      return state;
    }

    case actionTypes.HOMES_MESSAGE_RECEIVED:
    case actionTypes.WEBSOCKET_HELLO_MESSAGE_RECEIVED: {
      const data =
        action.type === actionTypes.HOMES_MESSAGE_RECEIVED
          ? action.data.data
          : action.data.homes || action.data.filteredHomes; // filteredHomes not needed after the backend change has been rolled out

      let homes = [];
      if (data && data.length > 0) {
        homes = data
          .map(home => {
            const addressLine1 = home?.property?.addressLine1
              ? home.property.addressLine1.replace(/\n/, ' ')
              : undefined;

            const friendlyName = home.friendlyName
              ? home.friendlyName
              : addressLine1;

            return {
              id: home.id,
              deviceRegistrationId: home.deviceRegistrationId,
              friendlyName,
              serialNumber: home.serialNumber,
              latitude: home.latitude,
              longitude: home.longitude,
              boiler: parseBoiler(home.boiler),
              si: parseSi(home.si),
              hpi: parseHpi(home.hpi),
              logic: parseLogic(home.logic),
              zigbeeRepeaters: home.zigbeeRepeaters || [],
              swc: home.swc,
              zones: home.zones.map(parseZone),
              cloudSupported: home.connectedDevice,
              controlFaults: home.controlFaults,
              geolocationDevices: home.geolocationDevices.map(device =>
                parseGeoDevice(device, home.deviceRegistrationId),
              ),
              geolocationEnabled: home.geolocationEnabled,
              awaySetpointEnabled: home.awaySetpointEnabled,
              awaySetpoint: home.awaySetpoint,
              geolocationAwayTemperatureAvailable:
                home.geolocationAwayTemperatureAvailable === true,
              weatherCompensationEnabled: home.weatherCompensationEnabled,
              weatherCompensationUserEnabled:
                home.weatherCompensationUserEnabled,
              homeRadius: home.homeRadius,
              awayRadius: home.awayRadius,
              role: home.role,
              awaitingZones: home.awaitingZones,
              type: home.type,
              haloDeviceServiceEnabled:
                home.haloDeviceServiceEnabled === true || false,
              dsrAutoAccept: home.dsrAutoAccept,
              property: home?.property || {},
            };
          })
          .sort(sortHomesById);
      }

      let { firstHelloWasEmpty } = state;
      if (!state.hadFirstHello) {
        firstHelloWasEmpty = homes.length === 0;
      }

      return {
        ...state,
        hadFirstHello: true,
        firstHelloWasEmpty,
        homes,
      };
    }

    case actionTypes.UPDATE_HOME_PROPERTY: {
      return {
        ...state,
        homes: state.homes.map(home =>
          home.id === action.homeId
            ? {
                ...home,
                property: action.property,
                friendlyName: home.friendlyName || action.property.addressLine1,
              }
            : home,
        ),
      };
    }

    // Demo mode only: merge confirmed values onto the reported zone state, as
    // a live message from the device would.
    case actionTypes.DEMO_ZONE_REPORTED: {
      const { type, homeId, zoneId, ...values } = action;

      return {
        ...state,
        homes: state.homes.map(home =>
          home.id === homeId
            ? {
                ...home,
                zones: home.zones.map(zone =>
                  zone.zoneId[0] === zoneId[0] && zone.zoneId[1] === zoneId[1]
                    ? { ...zone, ...values }
                    : zone,
                ),
              }
            : home,
        ),
      };
    }

    case actionTypes.WEBSOCKET_LIVE_RECEIVED: {
      if (!action.data.home || !action.data.home.id) {
        return state;
      }

      const previousHome = state.homes.find(h => h.id === action.data.home.id);

      if (!previousHome) {
        console.error(
          'Home received in live message before hello message',
          action,
        );
      }
      const addressLine1 = action.data.home?.property?.addressLine1
        ? action.data.home.property.addressLine1.replace(/\n/, ' ')
        : undefined;

      const friendlyName = action.data.home.friendlyName
        ? action.data.home.friendlyName
        : addressLine1;

      return {
        ...state,
        homes: [
          ...state.homes.filter(x => x.id !== action.data.home.id),
          {
            id: action.data.home.id,
            friendlyName,
            serialNumber: action.data.home.serialNumber,
            deviceRegistrationId: action.data.home.deviceRegistrationId,
            boiler: parseBoiler(action.data.home.boiler),
            si: parseSi(action.data.home.si),
            hpi: parseHpi(action.data.home.hpi),
            logic: parseLogic(action.data.home.logic),
            zigbeeRepeaters: action.data.home.zigbeeRepeaters || [],
            swc: action.data.home.swc,
            zones: action.data.home.zones.map(parseZone),
            cloudSupported: action.data.home.connectedDevice,
            controlFaults: action.data.home.controlFaults,
            geolocationDevices: action.data.home.geolocationDevices.map(
              device =>
                parseGeoDevice(device, action.data.home.deviceRegistrationId),
            ),
            geolocationEnabled: action.data.home.geolocationEnabled,
            awaySetpointEnabled: action.data.home.awaySetpointEnabled,
            awaySetpoint: action.data.home.awaySetpoint,
            geolocationAwayTemperatureAvailable:
              action.data.home.geolocationAwayTemperatureAvailable === true,
            weatherCompensationEnabled:
              action.data.home.weatherCompensationEnabled,
            weatherCompensationUserEnabled:
              action.data.home.weatherCompensationUserEnabled,
            homeRadius: action.data.home.homeRadius,
            awayRadius: action.data.home.awayRadius,
            latitude: action.data.home.latitude,
            longitude: action.data.home.longitude,
            awaitingZones: action.data.home.awaitingZones,
            // carry over role from hello message
            role: previousHome ? previousHome.role : 'Owner',
            type: action.data.home.type,
            haloDeviceServiceEnabled:
              action.data.home.haloDeviceServiceEnabled === true || false,
            dsrAutoAccept: action.data.home.dsrAutoAccept,
            property:
              action.data.home.property ||
              (previousHome ? previousHome.property : {}) ||
              {},
          },
        ].sort(sortHomesById),
      };
    }

    case actionTypes.GEOLOCATION_DEVICE_ADDED: {
      const foundHome = state.homes.find(
        home => home.id === action.data.homeId,
      );

      // if already added, don't add again
      if (
        foundHome.geolocationDevices.find(
          x => x.geolocationDeviceId === action.data.geolocationDevice.id,
        )
      ) {
        return state;
      }
      foundHome.geolocationDevices.push(action.data.geolocationDevice);

      return updateHomeGeolocationDevices(
        state,
        action.data.homeId,
        foundHome.geolocationDevices,
      );
    }

    case actionTypes.GEOLOCATION_DEVICE_REMOVED: {
      const foundHome = state.homes.find(
        home => home.id === action.data.homeId,
      );
      const filteredGeoDevices = foundHome.geolocationDevices.filter(
        device => device.id !== action.data.geolocationDevice.id,
      );

      return updateHomeGeolocationDevices(
        state,
        action.data.homeId,
        filteredGeoDevices,
      );
    }
    case actionTypes.GEOLOCATION_DEVICE_UPDATED: {
      const foundHome = state.homes.find(
        home => home.id === action.data.homeId,
      );
      const deviceIndex = foundHome.geolocationDevices.findIndex(
        device => device.id === action.data.geolocationDevice.id,
      );

      foundHome.geolocationDevices[deviceIndex].friendlyName =
        action.data.geolocationDevice.friendlyName;

      return updateHomeGeolocationDevices(
        state,
        action.data.homeId,
        foundHome.geolocationDevices,
      );
    }

    case actionTypes.WEBSOCKET_LIVE_DATA_RECEIVED: {
      const liveData = action.data?.metrics;

      return {
        ...state,
        liveData,
      };
    }

    case actionTypes.CLEAR_LIVE_DATA: {
      return {
        ...state,
        liveData: [],
      };
    }

    case actionTypes.DISABLE_DSR: {
      const homes = setDsrStatus(state, action.data.homeId, false);

      return { ...state, homes };
    }

    case actionTypes.ENABLE_DSR: {
      const homes = setDsrStatus(state, action.data.homeId, true);

      return { ...state, homes };
    }

    case actionTypes.DSR_AUTO_ACCEPT_UPDATE: {
      const homes = [];

      state.homes.forEach(home => {
        if (home.id === action.data.homeId) {
          homes.push({
            ...home,
            dsrAutoAccept: action.data.dsrAutoAccept,
          });
        } else {
          homes.push(home);
        }
      });

      return { ...state, homes };
    }

    default:
      return state;
  }
};

export const prtInitialState = [];
// [
//   {
//     deviceId: 'prt-123',
//     mode: 'auto',
//     temperature: 2150,
//     setpoint: 2300,
//     plusHoursActive: true,
//     flame: false
//   }
// ]

export const zone = (state = prtInitialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT_COMPLETED:
      return prtInitialState;

    //    case actionTypes.WEBSOCKET_HELLO_MESSAGE_RECEIVED:
    //      return [
    //        ...action.data.zones.map(zoneObj => ({
    //          prtId: zoneObj.serialNumber,
    //          mode: zoneObj.temperatureMode,
    //          temperature: zoneObj.localTemperature,
    //          setpoint: zoneObj.heatingSetpoint,
    //          flame: zoneObj.flame,
    //        })),
    //      ];

    case actionTypes.WEBSOCKET_PRT_LIVE_RECEIVED:
      return [
        ...state.filter(x => x.prtId !== action.data.serialNumber),
        {
          prtId: action.data.serialNumber,
          mode: action.data.temperatureMode,
          temperature: action.data.localTemperature,
          setpoint: action.data.heatingSetpoint,
          flame: action.data.flame,
        },
      ];

    default:
      return state;
  }
};
